import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Monitor } from "lucide-react";
import VesselHeader from "../../components/Vessel/VesselHeader";
// import DateRangePicker from "../../components/Common/AdditivesdateRangePicker";
import DateRangePicker from "../../components/Common/DateRangePicker";
import APCardsSection from "../../components/AdditivesPerformance/APCardsSection";
import APFuelUsage from "../../components/AdditivesPerformance/APFuelUsage";
import APEmissions from "../../components/AdditivesPerformance/APEmissions";
import APAdditivedUsed from "../../components/AdditivesPerformance/APAdditivedUsed";
import APCostSavingsChart from "../../components/AdditivesPerformance/APCostSavingsChart";
import { setDateRange } from "../../store/dateRangeSlice";

//API imports
import { getAdditiveFuelConsumption, getAdditiveMetadata, getAdditiveUsage, getEmissionData, getEmissionByDate, getFirstAdditiveUsageDate } from "../../services/additiveService";

const AdditivesPerformance = () => {
  const dispatch = useDispatch();
  const { currentVessel } = useSelector((state) => state.vesselOverview);
  const { startDate, endDate } = useSelector((state) => state.dateRange);
  const [metaData, setMetaData] = useState(null)
  const [fuelConsumption, setFuelConsumption] = useState(null)
  const [additiveUsage, setAdditiveUsage] = useState(null)
  const [emissionData, setEmissionData] = useState(null)
  const [emissionByDate, setEmissionByDate] = useState(null)
  const [firstAdditiveDate, setFirstAdditiveDate] = useState(null);
  const [loading, setLoading] = useState(true);
  
  const [hasAdditiveRecords, setHasAdditiveRecords] = useState(false);

  const initializeAdditiveData = async (vesselId = currentVessel?._id || currentVessel?.id) => {
    try {
      setLoading(true);

      const firstUsageResponse = await getFirstAdditiveUsageDate(vesselId);
      const firstAdditiveDate = firstUsageResponse.data.firstAdditiveDate;

      if (firstAdditiveDate) {
        setFirstAdditiveDate(new Date(firstAdditiveDate));
        setHasAdditiveRecords(true);

        const startDate = new Date(firstAdditiveDate);
        const endDate = new Date(firstAdditiveDate);
        endDate.setDate(endDate.getDate() + 6);

        dispatch(setDateRange({
          startDate: format(startDate, 'yyyy-MM-dd'),
          endDate: format(endDate, 'yyyy-MM-dd')
        }));

        await fetchAdditiveData(vesselId, startDate, endDate);
      } else {
        console.log("No additive usage records found");
        setFirstAdditiveDate(null);
        setHasAdditiveRecords(false);
        
        const defaultStartDate = new Date();
        const defaultEndDate = new Date();
        defaultEndDate.setDate(defaultEndDate.getDate() + 6);
        
        dispatch(setDateRange({
          startDate: format(defaultStartDate, 'yyyy-MM-dd'),
          endDate: format(defaultEndDate, 'yyyy-MM-dd')
        }));
        
        await fetchAdditiveData(vesselId, defaultStartDate, defaultEndDate);
      }
    } catch (error) {
      console.error("Failed to initialize additive data:", error);
      setHasAdditiveRecords(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (currentVessel?._id && hasAdditiveRecords) {
      fetchAdditiveData(currentVessel._id, startDate, endDate);
    }
  }, [startDate, endDate]);

  // useEffect(() => {
  //   if (currentVessel?._id) {
  //     initializeAdditiveData(currentVessel._id);
  //   }
  // }, [currentVessel]);

  const format = (date, formatStr) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const fetchAdditiveData = async (
    vesselId = currentVessel?._id || currentVessel?.id,
    start = startDate,
    end = endDate
  ) => {
    try {

      const response = await getAdditiveMetadata(vesselId, start, end);
      setMetaData(response);

      const response_fuel_consumption = await getAdditiveFuelConsumption(vesselId, start, end);
      setFuelConsumption(response_fuel_consumption);

      const response_additive_used = await getAdditiveUsage(vesselId, start, end);
      setAdditiveUsage(response_additive_used);

      const emissions_response = await getEmissionData(vesselId, start, end);
      setEmissionData(emissions_response);

      const emission_by_date = await getEmissionByDate(vesselId, start, end);
      setEmissionByDate(emission_by_date);

    } catch (error) {
      console.error("Failed to fetch main engine data:", error);
    }
  }

  useEffect(() => {
    console.log("currentVessel", currentVessel)
    if (currentVessel?._id) {
      fetchAdditiveData(currentVessel._id, startDate, endDate);
    }
  }, [currentVessel, startDate, endDate]);

  return (
    <div className="text-sm min-h-screen pr-4">
      <div className="flex items-center justify-between mb-8">
        <div className="flex items-center gap-3">
          <VesselHeader pageTitle="Analytics of Additives" />
        </div>
        <div className="flex">
          <DateRangePicker/>
        </div>
      </div>

      <div>
        {metaData?.data_quality?.has_after_data ? (
          <>
            <APCardsSection metaData={metaData} emissionData={emissionData} />
            <APFuelUsage fuelUsage={fuelConsumption} />
            <APEmissions emission={emissionByDate} />
            <div className="flex justify-center w-full">
              <APAdditivedUsed additiveUsage={additiveUsage} />
              {/* <APCostSavingsChart /> */}
            </div>
          </>
        ) : (
          <div className="flex flex-col items-center justify-center text-center p-6">
            <p className="text-lg font-semibold text-gray-800">
              No additive usage records found. Additive start date could not be determined.
            </p>
          </div>
        )}
      </div>
    </div>

  );
};

export default AdditivesPerformance;